import { render } from "./VocationalCaringForGodsPeople.vue?vue&type=template&id=24becda0&scoped=true"
import script from "./VocationalCaringForGodsPeople.vue?vue&type=script&lang=js"
export * from "./VocationalCaringForGodsPeople.vue?vue&type=script&lang=js"

import "./VocationalCaringForGodsPeople.vue?vue&type=style&index=0&id=24becda0&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24becda0"]])

export default __exports__